import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  background-color: ${({theme}) => theme.background};
  height: 100%;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  z-index: 10;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  .icon {
    color: ${({ theme }) => theme.arrowBack};
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(-2px);
  }
`;

export const TitleContainer = styled.div`
  margin-top: 50px;
  max-width: 100%;
  width: 100%;
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 32px;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  color: ${props => props.theme.textSubtitleCompliance};
  margin: 8px 0 32px 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
`;

export const ContentTitle = styled.h2`
  color: ${props => props.theme.text};
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
`;

export const ContentSubtitle = styled.p`
  color: ${props => props.theme.text};
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 400;
`;

export const TextAreaContainer = styled.div`
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
  padding-right: 5px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 240px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.border};
  background-color: ${({theme}) => theme.usersDivBackground || theme.formUserBackground};
  color: ${({theme}) => theme.text};
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  display: block;
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
`;

export const SaveButton = styled.button`
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 4px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
  
  &:disabled {
    background-color: ${({ theme }) => theme.primary};
    cursor: not-allowed;
  }
`; 